import React from 'react';
import { motion } from 'framer-motion';

const StatBox = ({ label, value, sub, accent }) => (
  <div className="flex flex-col items-center border border-[#658d71] bg-[rgba(0,0,0,0.12)] p-2 sm:p-3 flex-1 min-w-0">
    <span className="text-[8px] sm:text-[9px] uppercase tracking-widest text-[#658d71] font-bold mb-1">{label}</span>
    <span className={`text-lg sm:text-2xl font-black tabular-nums ${accent || 'text-white'}`}>{value ?? '--'}</span>
    {sub && <span className="text-[8px] text-[#a9c9b1] font-bold mt-0.5 tracking-widest">{sub}</span>}
  </div>
);

const SeasonHero = ({ standings }) => {
  const sox = standings?.find(t => t.team?.id === 111);
  if (!sox) return null;

  const w = sox.wins ?? '--';
  const l = sox.losses ?? '--';
  const pct = sox.winningPercentage ?? '--';
  const gb = sox.gamesBack === '-' ? '0.0' : (sox.gamesBack ?? '--');
  const streak = sox.streak?.streakCode ?? '--';
  const rank = standings ? standings.findIndex(t => t.team?.id === 111) + 1 : '--';
  const home = sox.records?.splitRecords?.find(r => r.type === 'home');
  const away = sox.records?.splitRecords?.find(r => r.type === 'away');

  return (
    <div className="border-2 border-[#658d71] bg-[rgba(0,0,0,0.08)] overflow-hidden">
      <div className="bg-[#386646] border-b-2 border-[#658d71] px-3 sm:px-4 py-2 sm:py-3 flex items-center justify-between">
        <div>
          <p className="text-[9px] tracking-widest uppercase text-[#a9c9b1] font-bold">AL East</p>
          <h2 className="text-base sm:text-2xl font-black tracking-widest text-[#d8ceb3] uppercase">Season Record</h2>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-3xl sm:text-5xl font-black text-white tabular-nums">{w}</span>
          <span className="text-xl font-black text-[#658d71]">–</span>
          <span className="text-3xl sm:text-5xl font-black text-[#658d71] tabular-nums">{l}</span>
        </div>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6">
        <StatBox label="Win %" value={pct} accent="text-[#d8ceb3]" />
        <StatBox label="GB" value={gb} accent={gb === '0.0' ? 'text-[#a9c9b1]' : 'text-[#c4333e]'} />
        <StatBox label="Rank" value={`#${rank}`} accent={rank === 1 ? 'text-[#d8ceb3]' : 'text-white'} />
        <StatBox label="Streak" value={streak} accent={streak?.startsWith('W') ? 'text-[#a9c9b1]' : 'text-[#c4333e]'} />
        <StatBox label="Home" value={home ? `${home.wins}-${home.losses}` : '--'} />
        <StatBox label="Away" value={away ? `${away.wins}-${away.losses}` : '--'} />
      </div>
    </div>
  );
};

export default SeasonHero;